import IMG1 from "../../assets/dashboard.png";
import IMG2 from "../../assets/coin_app.png";
import IMG3 from "../../assets/omnifood.png";

const data = [
  {
    id: 1,
    image: IMG1,
    title: "Admin Dashboard & Data Visualization (React)",
    github: "https://github.com/UlyanaBrataus/AdminDashboard",
    demo: "https://brataus-dashboard.netlify.app/",
  },
  {
    id: 2,
    image: IMG2,
    title: "Crypto Currency App (React)",
    github: "https://github.com/UlyanaBrataus/CryptoCoinApp",
    demo: "https://cryptocoin-brataus.netlify.app/",
  },
  {
    id: 3,
    image: IMG3,
    title: "Food Delivery Website (HTML, CSS, JS)",
    github: "https://github.com/UlyanaBrataus/Omnifood-project",
    demo: "https://omnifood-ulyana.netlify.app/",
  },
];

const PortData = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__item-cta">
                <a href={github} className="btn" target="_blank">
                  Github
                </a>
                <a href={demo} className="btn btn-primary" target="_blank">
                  Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default PortData;
